<mat-card class="speech-bubble" xmlns="http://www.w3.org/1999/html" *ngIf="ipadAppear">
  <div class="stacked" style="margin-top: 2%;"></div>
  <div class="titleFont" style="padding-bottom: 10px;">Peel Off Pile Entry </div>

  <div style="padding-left: 3%;">
    <mat-form-field class="newField" appearance="outline" >
      <mat-label>Container List</mat-label>
      <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
    </mat-form-field>
    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && didntEnterShit">Please Enter A Value</div>
    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && badSearch">No Data Found</div>
    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && notANumber">Visit Must Be Numeric</div>
    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && badChars">Invalid Character in {{containerNum}}</div>

    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && wrongCount40">Containers Must Be In Increments Of {{myParams.minCountDry40}}</div>
    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && wrongCount45">Containers Must Be In Increments Of {{myParams.minCountDry45}}</div>
    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && minNotMet">Must Enter At Least {{myParams.minCountReefer40}} Containers</div>
  </div>
  <mat-form-field class="myOption2"  appearance="outline">
    <mat-label>Group</mat-label>
    <mat-select  [(value)]="group" (selectionChange)="wipeOutScreen()" >
      <mat-option  *ngFor="let lr of groups" [value]="lr.code">{{lr.description}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="myOption2"  appearance="outline">
    <mat-label>Vessel/Voyage</mat-label>
    <mat-select  [(value)]="vessel" (selectionChange)="wipeOutScreen()" >
      <mat-option  *ngFor="let lr of vessels" [value]="lr.code">{{lr.description}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-toolbar style="background-color: white; padding-top: 2%; min-height: 35px">
    <mat-toolbar-row style="padding-left: 30%; height: 20px;">
      <div class="onoffswitch">
        <input type="checkbox" (click)="setCheckedField()"  class="onoffswitch-checkbox" id="myonoffswitch" >
        <label class="onoffswitch-label" for="myonoffswitch">
          <div class="onoffswitch-inner"></div>
          <div class="onoffswitch-switch"></div>
        </label>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-form-field class="myOption2"  appearance="outline" *ngIf="showTypes">
    <mat-label>Container Length</mat-label>
    <mat-select  [(value)]="savedList" (selectionChange)="wipeOutScreen()" >
      <mat-option  *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
    </mat-select>
  </mat-form-field>


  <div class="errorDiv2" style="text-align: center" *ngIf="submitted && maherError">{{peelOffParent.maherError}}</div>
  <div class="errorDiv2" style="text-align: center" *ngIf="submitted && N4Error">{{concatN4Error}}</div>
  <div style="padding-bottom: 10%; padding-top: 7%; text-align: center">
    <button mat-raised-button (click)="getSearchItems()"  class="blueButton" >Search</button>
  </div>


</mat-card>


<mat-card class="quickView" *ngIf="showQuickView">
  <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
    <tr>
      <td style="width: 20%">
        <div class="maher" (click)="myApp.showCharts()"></div>
      </td>
      <td style="width: 80%">
        <div >
          <mat-form-field class="search"  appearance="outline">
            <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
            <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/stacked.png" ></mat-icon>
            <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
          </mat-form-field>
        </div>
      </td>
      <td style="width: 20%" *ngIf="ipadApp">
        <div >
          <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
        </div>
      </td>
    </tr>
  </table>

  <div class="flex-item2" >
    <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
      <ng-container matColumnDef="check" >
        <mat-header-cell *matHeaderCellDef  matTooltip="click to check/uncheck all" class="myHeader"><img (click)="checkAll()" style="vertical-align: center;height:26px; width: 26px" src="assets/check_circle_white.png" ></mat-header-cell>
        <mat-cell style="    flex: 0 0 5% !important;" *matCellDef="let row">
          <mat-checkbox #mySel color="warn" (click)="$event.stopPropagation()" [hidden]="row.maherError!=null"
                        (change)="masterToggle(row,selection.isSelected(row)) ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="unit_id" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
        <mat-cell *matCellDef="let row" style="    flex: 0 0 15% !important;">{{row.unit_id}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="line_op" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.line_op}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="ves_voy" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Vessel/Voyage</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.ves_voy}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="maherError" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Messages</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.maherError}}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
      <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" ></mat-row>
    </mat-table>
    <mat-toolbar style="width: 100%; display: unset">

      <mat-toolbar-row style="width: 100%; padding-left: 2% ">
        <button mat-raised-button (click)="savePeel()"  class="blueButton" >Save</button>
        <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
      </mat-toolbar-row>
      <mat-toolbar-row style="width: 100%; max-height: 15px; padding-bottom: 1%; padding-left: 1%">
        <div class="errorDiv2" style="font-size: 15px" *ngIf="noneSelected">Must Choose At Least 1 Container</div>
        <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && maherError2">{{concatMaherError}}</div>
        <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && N4Error2">{{concatN4Error}}</div>
        <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && wrongCount40">Selections Must Be In Increments Of {{myParams.minCountDry40}}</div>
        <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && wrongCount45">Selections Must Be In Increments Of {{myParams.minCountDry45}}</div>
        <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && minNotMet">Must Enter At Least {{myParams.minCountReefer40}} Containers</div>

      </mat-toolbar-row>
    </mat-toolbar>
  </div>
</mat-card>
